function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const ishome = document.querySelector('.template--home main') !== null;

if (ishome) {
  window.onscroll = function() {
    if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
      gsap.to(".template--home .header-container", {background: "rgba(49, 47, 20, 1)", duration: .5});
    } else {
      gsap.to(".template--home .header-container", {background: "rgba(49, 47, 20, 0)", duration: .5});
    }
  };
}

let transitionUp = document.querySelectorAll('.js-transition-up');

transitionUp.forEach((elem) => {

  let transitionUpAnim = gsap.timeline({paused: true})
  .to(elem, 1, { y: 0, ease: "sine.out"});

  ScrollTrigger.create({
      trigger: elem,
      start: "top 66%",
      once: true,
      onEnter: ({progress, direction, isActive}) => transitionUpAnim.play(),
      markers: false
  });

});


let fadeIn = document.querySelectorAll('.js-fade-in');

fadeIn.forEach((elem) => {

    let fadeInAnim = gsap.timeline({paused: true})
    .fromTo(elem, 1, { opacity: 0 }, {opacity: 1, ease: "sine.out"})

    ScrollTrigger.create({
        trigger: elem,
        start: "top 66%",
        once: true,
        onEnter: ({progress, direction, isActive}) => fadeInAnim.play(),
        markers: false
    });

});


let storyHero = document.querySelector('.story-hero'),
    newsletter = document.querySelector('.js-newsletter-form'),
    closeNewsletter = document.querySelector('.js-close-newsletter');

if (storyHero && newsletter) {

    ScrollTrigger.create({
        trigger: storyHero,
        start: "bottom top",
        once: true,
        onEnter: ({progress, direction, isActive}) => setTimeout(function() { newsletter.classList.add('active') }, 3000),
        markers: false
    });

    closeNewsletter.addEventListener("click", () => {
        newsletter.classList.remove('active');
    })

}


// window.addEventListener("resize", function () {
//   console.log('huhhhh');
//   ScrollTrigger.refresh();
// });

// ScrollSmoother.create({
//   smooth: 1,
//   effects: true,
//   smoothTouch: 0.1
// });
